import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex uppercase items-center justify-center rounded-full border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-[var(--color-ring)] focus-visible:ring-[var(--color-ring)]/50 focus-visible:ring-[3px] aria-invalid:ring-[var(--color-destructive)]/20 dark:aria-invalid:ring-[var(--color-destructive)]/40 aria-invalid:border-(--color-destructive) transition-[color,box-shadow] overflow-hidden",
  {
    variants: {
      variant: {
        default:
          "border-transparent [background-color:var(--color-primary)] text-white hover:[background-color:var(--color-accent)",
        secondary:
          "border-transparent [background-color:var(--color-secondary)] [color:var(--neutral-50)] hover:[background-color:var(--color-secondary)]/90",
        destructive:
          "border-transparent [background-color:var(--color-destructive)] [color:var(--neutral-50)] hover:[background-color:var(--color-destructive)]/90 focus-visible:ring-(--color-destructive)/20 dark:focus-visible:ring-(--color-destructive)/40 dark:[background-color:var(--color-destructive)]/60",
        outline:
          "[color:var(--color-primary)] hover:[color:var(--color-accent)] border-(--color-primary) hover:border-[var(--color-accent)] bg-transparent",
        success:
          "border-transparent [background-color:var(--color-success)] [color:var(--neutral-50)]",
        info:
          "border-transparent [background-color:var(--color-info)] [color:var(--neutral-50)]",
        warning:
          "border-transparent [background-color:var(--color-warning)] [color:var(--neutral-50)]",
        gold:
          "border-transparent [background-color:var(--color-gold)] [color:var(--neutral-950)]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  asChild = false,
  ...props
}) {
  const Comp = asChild ? Slot : "span"

  return (
    <Comp
      data-slot="badge"
      className={cn(badgeVariants({ variant }), className)}
      {...props} />
  );
}

export { Badge, badgeVariants }
